const paths = {
  listModule: '/module/list',
  editModule: '/module/edit'
};

export default paths;
